import GlobalResource from "../../pages/common/globalresource";
import { useAuth } from "../../../usercontext";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import S12TopMenu from "../../student12/topmenu/topmenu";
import PageNotes from '../../pages/common/pagenotesnew'

function StudentResource() {
	const { profile } = useAuth()
	const slug = profile.id
	const isStudent911 = profile?.role === 'Student911'
	const isStudent12 = profile?.role === 'Student12'
	const isStudent = profile?.role === 'Student'
	return (
		<>
			{isStudent && <STopMenu slug={slug} activeMenu="Resource" />}
			{isStudent911 && <S911TopMenu slug={slug} activeMenu="Resource" />}
			{isStudent12 && <S12TopMenu slug={slug} activeMenu="Resource" />}
			<PageNotes type={'Student'} studentId={slug} />
			<GlobalResource slug={profile.id} isStudent={true} />;
		</>
	)
}

export default StudentResource;
